import { render, staticRenderFns } from "./Recycle.vue?vue&type=template&id=647191da&scoped=true"
import script from "./Recycle.vue?vue&type=script&lang=js"
export * from "./Recycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647191da",
  null
  
)

export default component.exports